export const STORE_URLS = {
  ios: "https://apps.apple.com/us/app/streamplace/id6535653195",
  android: "https://play.google.com/store/apps/details?id=tv.aquareum",
};

export const STORE_LABELS = {
  ios: "App Store",
  android: "Google Play",
};
